import React from 'react';
import CustomImage from '../../../components/custom-image';

const WomenEmp = () => {
  return (
    <div className="accordion-body">
      <div className="sd-content">
          <div className="left">
            <div className="blue-box">
              <p className="feature-title"><strong>Key Features</strong></p>
              <div className="sd-column">
                <div className="col-3">
                  <p className="feature-subtitle">More than</p>
                  <p className="bold-text blue-text">15</p>
                  <p className="feature-benifit">initiatives across our Group companies</p>
                </div>
                <div className="col-3">
                  <p className="feature-subtitle">More than</p>
                  <p className="bold-text blue-text">48,000</p>
                  <p className="feature-benifit">women beneﬁt from these programs</p>
                </div>
                <div className="col-3">
                  <p className="feature-subtitle">More than</p>
                  <p className="bold-text blue-text">3,100</p>
                  <p className="feature-benifit">SHGs &</p>
                  <p className="bold-text blue-text">4,000+</p>
                  <p className="feature-benifit">micro-enterprises formed</p>
                </div>
              </div>
              
            </div>
            <div className="bottom-content">
              <p><strong>Types of Interventions</strong></p>
              <p>
              Self-Help Groups (SHG); Women’s co-operatives; Micro-enterprises
              </p>
            </div>
          </div>
          <div className="right">
            <div className="img-wrapper">
              <CustomImage className="custom-image" imageName="women-empowerment.jpg" alt="Women Empowerment" maxWidth="768" />
            </div>
          </div>
      </div>
    </div>
  );
};

export default WomenEmp;
